<template>
  <div class="background-div" :style="{
    backgroundImage: `url(${require('@/assets/index_bg.jpg')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }">
    <!--时间筛选-->
    <van-sticky>
      <van-tabs class="title" v-model="tab" ref="tabRef" title-active-color="#1989fa" @change="onTabChange">
        <van-tab name="day" title="本日" />
        <van-tab name="week" title="本周" />
        <van-tab name="month" title="本月" />
        <van-tab name="custom">
          <template #title>
            <span @click="calendarShow"><van-icon name="notes-o" />自定义</span>
          </template>
        </van-tab>
      </van-tabs>
      <div style="height: 2px;background-color: #379bff;"></div>
    </van-sticky>
    <br />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!--营业数据-->
      <el-card shadow="always" class="retail-card" :body-style="{ padding: '10px' }" style="border-radius: 15px;">
        <van-cell :title="dateStr + '业绩'" is-link value="业绩趋势" @click="scrollToBottom" />
        <br />
        <van-row>
          <van-col span="12">
            <van-circle v-model="currentRate" :rate="completionRate" :speed="100" :text="circleText" />
          </van-col>
          <van-col span="12">
            <div class="completionText">总销售额</div>
            <div style="font-size: 2rem; color: #FF7700;">￥{{ totalSalesAmount | AmtFormat }}</div>
            <div class="completionText">{{ dateStr }}指标</div>
            <div>￥{{ totAmtMark | AmtFormat }}</div>
          </van-col>
        </van-row>
      </el-card>
      <!--业绩汇总-->
      <br />
      <div>
        <van-cell>
          <template #title>
            <div class="van-sidebar-item van-sidebar-item--select">业绩汇总</div>
          </template>
        </van-cell>
        <van-grid :column-num="3">
          <van-grid-item>
            <div class="tot-content">{{ totalSalesCount | AmtFormat }}</div>
            <div class="tot-title">销售单数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ totalSalesQuantity | AmtFormat }}</div>
            <div class="tot-title">销售件数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ vipSalesRatio }}</div>
            <div class="tot-title">会销占比</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ averageTransactionValue }}</div>
            <div class="tot-title">客单价</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ averageItemValue }}</div>
            <div class="tot-title">件单价</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ jointRate }}</div>
            <div class="tot-title">连带率</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ prepayCount | AmtFormat }}</div>
            <div class="tot-title">预存笔数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ prepayAmount | AmtFormat }}</div>
            <div class="tot-title">预存金额</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ repurchaseCount | AmtFormat }}</div>
            <div class="tot-title">复购笔数</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ repurchaseAmount | AmtFormat }}</div>
            <div class="tot-title">复购金额</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ repurchaseRate }}</div>
            <div class="tot-title">复购率</div>
          </van-grid-item>
          <van-grid-item>
            <div class="tot-content">{{ newVipCount }}</div>
            <div class="tot-title">新增会员数</div>
          </van-grid-item>
        </van-grid>
      </div>
      <!--商品-->
      <div>
        <van-cell class="cell-top" value="查看更多" @click="toPdtRank" is-link>
          <template #title>
            <div class="van-sidebar-item van-sidebar-item--select">
              {{ dateStr }}畅销商品&nbsp;<van-tag type="warning">top</van-tag>
            </div>
          </template>
        </van-cell>
        <div class="scroll-wrapper">
          <div v-for="(item, index) in pdtRankList" :key="item.barCode" class="square">
            <div class="image-container">
              <van-image width="6rem" height="6rem" fit="contain" :src="imgUrl + item.productName" />
              <div v-if="index == 0" class="medal-tag medal-gold">
                TOP1
              </div>
              <div v-else-if="index == 1" class="medal-tag medal-silver">
                TOP2
              </div>
              <div v-else-if="index == 2" class="medal-tag medal-bronze">
                TOP3
              </div>
            </div>
            <div class="pdt-info">{{ item.productCode }} {{ item.productName }}</div>
            <div class="pdt-rate">{{ item.salesRatio }}</div>
          </div>
        </div>
      </div>
      <!--员工-->
      <div>
        <van-cell class="cell-top" value="查看更多" @click="toEmpRank" is-link>
          <template #title>
            <div class="van-sidebar-item van-sidebar-item--select">
              {{ dateStr }}员工&nbsp;<van-tag type="warning">top</van-tag>
            </div>
          </template>
        </van-cell>
        <div class="scroll-wrapper">
          <div v-for="(item, index) in empRankList" :key="index" class="emp-square">
            <div class="employee-card">
              <div v-if="index == 0" class="rank-badge"><img width="24px" src="@/assets/gold.png" /></div>
              <div v-else-if="index == 1" class="rank-badge"><img width="24px" src="@/assets/silver.png" /></div>
              <div v-else-if="index == 2" class="rank-badge"><img width="24px" src="@/assets/bronze.png" /></div>
              <div v-else class="rank-num">{{ index + 1 }}</div>
              <div class="avatar-container">
                <div class="avatar">
                  {{ getShortName(item.employeeName) }}
                </div>
              </div>
              <div class="employee-name">{{ item.employeeName }}</div>
              <div class="employee-amt">￥{{ item.salesAmount | AmtFormat }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--业绩图-->
      <div>
        <van-cell class="cell-top">
          <template #title>
            <div class="van-sidebar-item van-sidebar-item--select">
              {{ dateStr }}业绩趋势图
            </div>
          </template>
          <template #default>
            <van-tabs class="retail" v-model="graphType" @change="getChartData">
              <van-tab name="day" title="销售业绩" />
              <van-tab name="time" title="时段趋势" />
            </van-tabs>
          </template>
        </van-cell>
        <!--折线图-->
        <br />
        <ve-line :data="chartData"></ve-line>
      </div>
    </van-pull-refresh>
    <!--日期过滤-->
    <van-calendar v-model="dateShow" class="calendar" :min-date="minDate" :max-date="maxDate" type="range"
      @confirm="onDateConfirm" />
  </div>
</template>

<script>
import { reqSummary, reqEmployeeSales, reqProductSales, reqDailySummary, reqHourlySummary } from "@/api/board";

export default {
  name: "index",

  data() {
    return {
      imgUrl: Glob.IMG_URL,
      isLoading: false,

      tab: 'day',
      dateStr: '本日',

      dateShow: false,
      minDate: null,
      maxDate: null,
      //完成率
      currentRate: 0,
      completionRate: 0,
      totalSalesAmount: 0,
      totAmtMark: 0,
      //业绩汇总
      totalSalesCount: 0,
      totalSalesQuantity: 0,
      vipSalesRatio: "0.00%",
      averageTransactionValue: 0,
      averageItemValue: 0,
      jointRate: 0,
      prepayCount: 0,
      prepayAmount: 0,
      repurchaseCount: 0,
      repurchaseAmount: 0,
      repurchaseRate: "0.00%",
      newVipCount: 0,

      //商品
      pdtRankList: [],

      //员工
      empRankList: [],

      graphType: 'day',
      //折线图
      chartData: {
        columns: ["日期", "销售业绩", "销售指标", "完成率"],
        rows: [],
      },

      //请求参数
      reqData: {
        startDate: null,
        endDate: null,
        pageNum: 1,
        pageSize: 10,
      },
      //滚动
      scrollProgress: 0,
    }
  },

  computed: {
    circleText() {
      return "完成率\n" + this.currentRate.toFixed(0) + '%';
    },
  },

  created() {
    //初始化数据
    this.tab = 'day';
    this.isLoading = false;
    this.dateStr = '本日';
    let nowDate = new Date();
    this.reqData.startDate = this.$moment(nowDate).format('YYYYMMDD');
    this.reqData.endDate = this.$moment(nowDate).format('YYYYMMDD');
    this.dateShow = false;
    this.minDate = new Date(this.$moment(nowDate).subtract(2, 'year').startOf('year').format());
    this.maxDate = nowDate;
    //获取业绩
    this.getSummary();
    //获取员工数据
    this.getEmployeeSales();
    //获取商品数据
    this.getProductSales();
    //获取折线图
    this.getChartData();
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // 初始化状态
  },

  methods: {
    //跳转到畅销商品
    toPdtRank() {
      this.$router.push({
        name: "pdtRank", params: {
          startDate: this.reqData.startDate, endDate: this.reqData.endDate, tab: this.tab,
          dateStr: this.dateStr,
        }
      });
    },
    //跳转到员工
    toEmpRank() {
      this.$router.push({
        name: "empRank", params: {
          startDate: this.reqData.startDate, endDate: this.reqData.endDate, tab: this.tab,
          dateStr: this.dateStr,
        }
      });
    },
    //刷新
    onRefresh() {
      //获取总业绩
      this.getSummary().finally(() => {
        this.isLoading = false;
      });
      //获取员工数据
      this.getEmployeeSales();
      //获取商品数据
      this.getProductSales();
      //获取折线图
      this.getChartData();
    },
    //截取名字
    getShortName(name) {
      // 如果名字长度为3，取后两个字
      if (name.length === 3) {
        return name.substring(1);
      }
      // 如果名字长度大于3，取最后两个字
      if (name.length > 3) {
        return name.substring(name.length - 2);
      }
      return name;
    },
    //切换tab
    onTabChange(name) {
      //获取默认日期  this.$moment('20230102').format()
      let nowDate = new Date();
      if (name == 'day') {
        this.reqData.startDate = this.$moment(nowDate).format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).format('YYYYMMDD');
        this.dateStr = '本日';
      } else if (name == 'week') {
        this.reqData.startDate = this.$moment(nowDate).startOf("isoWeek").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("isoWeek").format('YYYYMMDD');
        this.dateStr = '本周';
      } else if (name == 'month') {
        this.reqData.startDate = this.$moment(nowDate).startOf("month").format('YYYYMMDD');
        this.reqData.endDate = this.$moment(nowDate).endOf("month").format('YYYYMMDD');
        this.dateStr = '本月';
      }
      //获取业绩
      this.getSummary();
      //获取员工数据
      this.getEmployeeSales();
      //获取商品数据
      this.getProductSales();
      //获取折线图
      this.getChartData();
    },
    //日期选择
    calendarShow() {
      this.dateShow = true;
    },
    //选择日期
    onDateConfirm(date) {
      this.dateShow = false;
      this.reqData.startDate = this.$moment(date[0]).format('YYYYMMDD');
      this.reqData.endDate = this.$moment(date[1]).format('YYYYMMDD');
      this.dateStr = this.$moment(date[0]).format('M.D') + "-" + this.$moment(date[1]).format('M.D');
      //获取业绩
      this.getSummary();
      //获取员工数据
      this.getEmployeeSales();
      //获取商品数据
      this.getProductSales();
      //获取折线图
      this.getChartData();
    },
    //获取总业绩
    getSummary() {
      return new Promise((resolve, reject) => {
        //发出请求
        reqSummary(this.reqData).then((res) => {
          this.completionRate = res.completionRate;
          this.totalSalesAmount = res.totalSalesAmount;
          this.totAmtMark = res.totAmtMark;
          this.totalSalesCount = res.totalSalesCount;
          this.totalSalesQuantity = res.totalSalesQuantity;
          this.vipSalesRatio = res.vipSalesRatio;
          this.averageTransactionValue = res.averageTransactionValue;
          this.averageItemValue = res.averageItemValue;
          this.jointRate = res.jointRate;
          this.prepayCount = res.prepayCount;
          this.prepayAmount = res.prepayAmount;
          this.repurchaseCount = res.repurchaseCount;
          this.repurchaseAmount = res.repurchaseAmount;
          this.repurchaseRate = res.repurchaseRate;
          this.newVipCount = res.newVipCount;
          // 成功时调用resolve
          resolve();
        }).catch(error => {
          // 失败时调用reject
          reject();
        });
      });
    },
    //获取员工排行数据
    getEmployeeSales() {
      //发出请求
      reqEmployeeSales(this.reqData).then((res) => {
        this.empRankList = res.data;
      });
    },
    //获取商品排行数据
    getProductSales() {
      //发出请求
      reqProductSales(this.reqData).then((res) => {
        this.pdtRankList = res.data;
      });
    },
    // 滚动到页面底部
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    },
    //滚动监听
    handleScroll() {
      // 更新滚动进度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const progress = (scrollTop / (docHeight - windowHeight)) * 100;
      this.scrollProgress = Math.min(100, Math.max(0, progress));
    },
    //获取折现图数据
    getChartData() {
      if (this.graphType == 'day') {
        //获取销售业绩
        this.chartData = {
          columns: ["日期", "销售业绩", "销售指标", "完成率"],
          rows: [],
        };
        //发出请求
        reqDailySummary(this.reqData).then((res) => {
          //解析折线图数据
          res.forEach((item) => {
            this.chartData.rows.push(
              {
                "日期": item.saleDate,
                "销售业绩": item.salesAmount,
                "销售指标": item.saleStarget,
                "完成率": item.completionRate,
              });
          });
        });
      } else {
        //获取时段趋势
        this.chartData = {
          columns: ["时段", "销售额", "销售件数", "销售笔数", "客单价"],
          rows: [],
        };
        reqHourlySummary(this.reqData).then((res) => {
          //解析折线图数据
          res.forEach((item) => {
            this.chartData.rows.push(
              {
                "时段": item.timesegment,
                "销售额": item.salesAmount,
                "销售件数": item.salesQuantity,
                "销售笔数": item.transactionCount,
                "客单价": item.averageTransactionValue,
              });
          });
        });
      }
    },
  },
}
</script>

<style scoped lang="less">
.background-div {
  width: 100%;
  height: 600px;
  /* 必须设置高度 */
}

/deep/ .title .van-tabs__nav {
  background-color: #379bff;
}

/deep/ .title .van-tab--active {
  color: #FFF !important;
}

/deep/ .title .van-tabs__line {
  background-color: #FFF;
}

/deep/ .title .van-tab {
  color: #FFF;
}

.retail-card {
  width: 90%;
  margin-left: 1rem;
}

/deep/ .van-cell {
  padding: 0px 0px;
  position: initial;
}

/deep/ .van-circle__text {
  white-space: pre-line;
}

/deep/ .van-circle__layer {
  stroke: rgb(248, 248, 248);
}

.completionText {
  color: #969799;
  font-size: 0.7rem;
  margin-top: 5px;
}

.tot-title {
  font-size: 0.7rem;
  color: #646566;
}

.tot-content {
  font-size: 1.5rem;
  font-family: "Arial";
  color: #1e88e5;
}

/deep/ .cell-top.van-cell {
  padding: 0px 0px;
  position: relative;
}

/deep/ .cell-top .van-cell__value {
  padding-top: 1rem;
}

/deep/ .cell-top .van-cell__right-icon {
  padding-top: 1rem;
}

/* 基础布局 */
.container {
  overflow: hidden;
  padding: 8px 0;
  /* 纵向留白 */
}

/* 滚动容器 */
.scroll-wrapper {
  display: flex;
  overflow-x: auto;
  /* 横向滚动 */
  scrollbar-width: none;
  /* Firefox隐藏滚动条 */
  padding: 0 2px;
  /* 边缘留白 */
  gap: 8px;
  /* 元素间距 */
}

/* 隐藏滚动条 (Chrome/Safari) */
.scroll-wrapper::-webkit-scrollbar {
  display: none;
}

/* 正方形元素 */
.square {
  width: 6rem;
  height: 10rem;
}

.pdt-info {
  font-size: 24px;
}

.pdt-rate {
  font-size: 20px;
}

/* 图片容器（添加相对定位） */
.image-container {
  position: relative;
  width: 100%;
  height: 70%;
  /* 根据实际布局调整 */
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}

/* 奖牌标签基础样式 */
.medal-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transform: rotate(15deg);
  /* 轻微旋转增加设计感 */

  /* 添加光泽效果 */
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.3) 0%, transparent 50%);
}

/* 金牌样式 */
.medal-gold {
  background-color: #FFD700;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* 银牌样式 */
.medal-silver {
  background-color: #C0C0C0;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* 铜牌样式 */
.medal-bronze {
  background-color: #CD7F32;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

.employee-card {
  flex: 0 0 auto;
  width: 6rem;
  background: white;
  border-radius: 18px;
  padding: 0.2rem 0.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  border: 1px solid #eef2f7;
}

.avatar-container {
  position: relative;
}

.avatar {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background: #5cabff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  color: white;
  box-shadow: 0 6px 12px rgba(33, 150, 243, 0.4);
}

.employee-name {
  margin-top: 0.7rem;
  text-align: center;
  font-size: 0.8rem;
}

.employee-amt {
  margin-top: 0px;
  text-align: center;
  color: #ee0a24;
  font-size: 0.8rem;
}

.emp-square {
  width: 6rem;
  height: 8rem;
}

.rank-badge {
  position: absolute;
  z-index: 9;
  top: 3.8rem;
  left: 2.3rem;
}

.rank-num {
  background: #969799;
  position: absolute;
  z-index: 9;
  top: 4rem;
  left: 2.5rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/deep/ .retail .van-tabs__line {
  background-color: #379bff;
}

/deep/ .retail .van-tab--active {
  color: #379bff;
}

/deep/ .van-calendar__day--start {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  background-color: #c8dcff;
}

/deep/ .van-calendar__day--end {
  background-color: #379bff;
}

/deep/ .van-calendar__day--middle {
  color: #379bff;
}

/deep/ .calendar .van-button--danger {
  color: #fff;
  background-color: #379bff;
  border: 1px solid #379bff;
}

/deep/ .van-loading__spinner--circular {
  color: #fff;
}

/deep/ .van-loading__text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/board/index.vue